<template>
  <div class="rule-item">
    <div class="rule-header-wrapper">
      <div class="rule-header">
        <span class="required" v-if="isMandatory">*</span>
        <span class="label">事故出险</span>
        <i class="el-icon-delete delete-btn" @click="emit('remove')" v-if="!isMandatory"></i>
      </div>
      <div class="desc">请确认车辆已投保险种。当发生交通事故通过保险理赔时，承租人需按责任类型支付相关费用。</div>
    </div>
    <RuleTip :tip="tip" />
    <div class="rule-body">
      <div class="checkbox-row">
        <el-checkbox :value="modelValue.strongRisk" disabled :true-label="1" :false-label="0">已投交强险</el-checkbox>
      </div>
      <div class="checkbox-row">
        <el-checkbox :value="modelValue.hasCommercialInsurance" @change="handleCommercialInsuranceChange">已投商业险</el-checkbox>
      </div>
      <div class="sub-checkbox-row" v-if="modelValue.hasCommercialInsurance">
        <el-checkbox :value="modelValue.thirdParty" @change="updateField('thirdParty', $event)" label="第三者责任险" :true-label="1" :false-label="0"></el-checkbox>
        <el-checkbox :value="modelValue.carDamage" @change="updateField('carDamage', $event)" label="车辆损失险" :true-label="1" :false-label="0"></el-checkbox>
        <el-checkbox :value="modelValue.carLost" @change="updateField('carLost', $event)" label="全车盗抢险" :true-label="1" :false-label="0"></el-checkbox>
        <el-checkbox :value="modelValue.people" @change="updateField('people', $event)" label="车上人员责任险" :true-label="1" :false-label="0"></el-checkbox>
        <el-checkbox :value="modelValue.nonDeductible" @change="updateField('nonDeductible', $event)" label="不计免赔险" :true-label="1" :false-label="0"></el-checkbox>
      </div>

      <el-table :data="liabilityConfig" border style="width: 100%; margin-top: 10px;">
        <el-table-column prop="label" label="事故责任类型" width="120"></el-table-column>
        <el-table-column label="保险上浮费" min-width="200" class-name="validate-error-overflow" header-align="center">
          <template slot-scope="scope">
            <el-form-item :prop="`${propPrefix}.${scope.row.feeKey}`" :rules="getRangeDecimalRules(10000, 0, 2)" style="margin-bottom: 0;">
              <el-input
                :value="modelValue[scope.row.feeKey]"
                placeholder="请输入"
                size="small"
                v-number:float
                @input="updateField(scope.row.feeKey, $event)"
              >
                <template slot="append">元/次</template>
              </el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column label="车辆折旧费" min-width="200" class-name="validate-error-overflow with-prefix" header-align="center">
          <template slot-scope="scope">
            <el-form-item :prop="`${propPrefix}.${scope.row.depreKey}`" :rules="getRangeDecimalRules(100, 0, 2)" style="margin-bottom: 0;">
              <el-input
                :value="modelValue[scope.row.depreKey]"
                placeholder="请输入"
                size="small"
                v-number:float
                @input="updateField(scope.row.depreKey, $event)"
              >
                <template slot="prepend">保险定损金额的</template>
                <template slot="suffix">
                  <span class="input-suffix-unit">%/次</span>
                </template>
              </el-input>
            </el-form-item>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import { getRangeDecimalRules } from './utils'
import RuleTip from './RuleTip.vue'

const props = defineProps({
  modelValue: {
    type: Object,
    required: true,
  },
  propPrefix: {
    type: String,
    required: true,
  },
  tip: {
    type: String,
    default: '',
  },
  isMandatory: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['update:modelValue', 'remove'])

const liabilityConfig = [
  { label: '全责', feeKey: 'accidentLiabilityFullFee', depreKey: 'vehicleDepreciationFullPercent' },
  { label: '主责', feeKey: 'accidentLiabilityMajorFee', depreKey: 'vehicleDepreciationMajorPercent' },
  { label: '次责', feeKey: 'accidentLiabilitySecondaryFee', depreKey: 'vehicleDepreciationSecondaryPercent' },
  { label: '同责', feeKey: 'accidentLiabilitySharedFee', depreKey: 'vehicleDepreciationSharedPercent' },
  { label: '无责', feeKey: 'accidentLiabilityNoFee', depreKey: 'vehicleDepreciationNoPercent' },
]

const updateField = (key, value) => {
  const newItem = { ...props.modelValue, [key]: value }
  emit('update:modelValue', newItem)
}

const handleCommercialInsuranceChange = (val) => {
  if (!val) {
    const newItem = {
      ...props.modelValue,
      thirdParty: 0,
      carDamage: 0,
      carLost: 0,
      people: 0,
      nonDeductible: 0,
      hasCommercialInsurance: val,
    }
    emit('update:modelValue', newItem)
  } else {
    updateField('hasCommercialInsurance', val)
  }
}

onMounted(() => {
  if (props.modelValue.strongRisk !== 1) {
    updateField('strongRisk', 1)
  }
})
</script>

<style lang="scss" scoped>
@import './rules.scss';

::v-deep th.validate-error-overflow .cell {
  margin-bottom: 0;
}

::v-deep .validate-error-overflow.with-prefix .el-form-item__error {
  padding-left: 140px;
}
</style>
